import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CommonSizeContainer from './CommonSizeContainer';
import { DropDownArrow, RightArrowIcon } from '../assets/Icons/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { useOnClickOutside } from '../Hooks/useOutSideClick';

const LegalSideLayout = ({ children }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [legalType] = useState([
    {
      name: t('ForCustomer'),
      isOpen: true,
      legalOptions: [
        {
          id: 1,
          name: t('ForCustomer1Title'),
          link: '/legal/terms-of-service',
        },
        {
          id: 2,
          name: t('ForCustomer2Title'),
          link: '/legal/product-specific-terms',
        },
        {
          id: 3,
          name: t('ForCustomer3Title'),
          link: '/legal/dpa',
        },
        {
          id: 4,
          name: t('ForCustomer4Title'),
          link: '/legal/acceptable-use',
        },
      ],
    },
    {
      name: t('ForDevelopers'),
      isOpen: false,
      legalOptions: [
        {
          id: 1,
          name: t('ForDevelopers1Title'),
          link: '/legal/developer-terms',
        },
        {
          id: 2,
          name: t('ForDevelopers2Title'),
          link: '/legal/developer-policy',
        },
        {
          id: 3,
          name: t('ForDevelopers3Title'),
          link: '/legal/acceptable-use',
        },
      ],
    },
    {
      name: t('ForEveryone'),
      isOpen: false,
      legalOptions: [
        {
          id: 1,
          name: t('ForEveryone1Title'),
          link: '/legal/website-terms-of-use',
        },
        {
          id: 2,
          name: t('ForEveryone2Title'),
          link: '/legal/website-accessibility',
        },
        {
          id: 3,
          name: t('ForEveryone3Title'),
          link: '/legal/privacy-policy',
        },
        {
          id: 4,
          name: t('ForEveryone4Title'),
          link: '/legal/cookie-policy',
        },
        {
          id: 5,
          name: t('ForEveryone5Title'),
          link: '/legal/digital-services-act',
        },
      ],
    },
  ]);
  const [isOpen, setIsOpen] = useState(true);
  const [openLegal, setOpenLegal] = useState(false);
  const [selectedLegalType, setSelectedLegalType] = useState(
    location.pathname === '/legal/terms-of-service'
      ? legalType[0].legalOptions[0].name
      : location.pathname === '/legal/product-specific-terms'
      ? legalType[0].legalOptions[1].name
      : location.pathname === '/legal/dpa'
      ? legalType[0].legalOptions[2].name
      : location.pathname === '/legal/acceptable-use'
      ? legalType[0].legalOptions[3].name
      : location.pathname === '/legal/developer-terms'
      ? legalType[1].legalOptions[0].name
      : location.pathname === '/legal/developer-policy'
      ? legalType[1].legalOptions[1].name
      : location.pathname === '/legal/website-terms-of-use'
      ? legalType[2].legalOptions[0].name
      : location.pathname === '/legal/website-accessibility'
      ? legalType[2].legalOptions[1].name
      : location.pathname === '/legal/privacy-policy'
      ? legalType[2].legalOptions[2].name
      : location.pathname === '/legal/cookie-policy'
      ? legalType[2].legalOptions[3].name
      : location.pathname === '/legal/digital-services-act'
      ? legalType[2].legalOptions[4].name
      : ''
  );
  const dropdownRef = useRef();
  useOnClickOutside(dropdownRef, () => {
    if (openLegal) {
      setOpenLegal(false);
    }
  });

  const [selectedValue, setSelectedValue] = useState(
    location.pathname === '/legal/terms-of-service' ||
      location.pathname === '/legal/product-specific-terms' ||
      location.pathname === '/legal/dpa' ||
      location.pathname === '/legal/acceptable-use'
      ? legalType[0]
      : location.pathname === '/legal/developer-terms' ||
        location.pathname === '/legal/developer-policy' ||
        location.pathname === '/legal/acceptable-use'
      ? legalType[1]
      : legalType[2]
  );
  const handleClick = (name, link) => {
    setSelectedLegalType(name);
    navigate(link);
  };

  const handleStorage = () => {
    localStorage.removeItem('scrollPositionT');
    localStorage.removeItem('scrollPositionS');
    localStorage.removeItem('scrollPositionDPA');
    localStorage.removeItem('scrollPositionA');
    localStorage.removeItem('scrollPositionD');
    localStorage.removeItem('scrollPositionDT');
    localStorage.removeItem('scrollPositionWT');
    localStorage.removeItem('scrollPositionWA');
    localStorage.removeItem('scrollPositionPP');
    localStorage.removeItem('scrollPositionCP');
    localStorage.removeItem('scrollPositionSD');
    localStorage.removeItem('appsCount');
  };
  return (
    <div>
      <div className="bg-BgPrimary">
        <div className="max-w-[1240px] max_xl:max-w-[980px] m-auto py-[100px] max_md:py-[40px] max_md:px-10 max_sm:px-5">
          <h1 className="headingText text-center">{t('LegalRepository')}</h1>
        </div>
      </div>
      <CommonSizeContainer>
        <div className="flex justify-between max_md:flex-col max_md:gap-[60px] max_sm:gap-10">
          <div className="w-[220px] flex flex-col gap-2 h-fit border-l-[1px] border-LightOutline max_md:hidden sticky top-16">
            {legalType.map((legal, index1) => (
              <React.Fragment key={index1}>
                <div
                  className={`px-5 py-3 smallText16 cursor-pointer transition-colors duration-400 flex justify-between ${
                    legal.name === selectedValue.name
                      ? 'bg-ButtonPrimary text-white'
                      : 'text-LightSecondary'
                  }`}
                  onClick={() => {
                    if (legal.name === selectedValue.name) {
                      setIsOpen(!isOpen);
                    } else {
                      setIsOpen(true);
                      setSelectedValue(legal);
                    }
                  }}
                >
                  <p>{legal.name}</p>
                  <div
                    className={`transform transition-transform duration-200 ${
                      isOpen && legal.name === selectedValue.name
                        ? 'rotate-90'
                        : ''
                    }`}
                  >
                    <RightArrowIcon
                      color={
                        legal.name === selectedValue.name
                          ? '#ffffff'
                          : '#8C90A5'
                      }
                    />
                  </div>
                </div>
                {isOpen && legal.name === selectedValue.name && (
                  <>
                    <div className="mt-2 flex flex-col gap-[14px] pl-5 pr-[10px]">
                      {legal.legalOptions.map((option, index) => (
                        <div className="flex gap-3" key={index}>
                          <p
                            className={`mt-2 w-[6px] h-[6px] rounded-full ${
                              location.pathname === option.link
                                ? 'bg-ButtonPrimary'
                                : 'bg-LightSecondary'
                            }`}
                          ></p>
                          <p
                            className={`cursor-pointer w-[calc(100%-18px)] smallText16  ${
                              location.pathname === option.link
                                ? 'text-ButtonPrimary'
                                : 'text-LightSecondary'
                            }`}
                            onClick={() => {
                              navigate(option.link);
                              handleStorage()
                              setTimeout(() => {
                                window.scrollTo(0, 0);
                              }, 100);
                            }}
                          >
                            {option.name}
                          </p>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </React.Fragment>
            ))}
          </div>
          {/* Tablate and Mobile view */}
          <div className="hidden max_md:block w-full">
            <div
              className={`relative border-[1px] border-LightOutline py-3 px-5 rounded-[10px] font-DMSansFont text-textSmall font-normal  ${
                selectedLegalType
                  ? 'font-semibold text-LightPrimary'
                  : 'font-medium text-LightTextParagraph'
              }`}
              onClick={() => setOpenLegal(!openLegal)}
              ref={dropdownRef}
            >
              {selectedLegalType ? selectedLegalType : 'Legal repository'}
              <div
                className={`absolute right-5 top-3  cursor-pointer transition-transform duration-200 ${
                  openLegal ? 'rotate-180' : ''
                }`}
              >
                <DropDownArrow />
              </div>

              {openLegal && (
                <>
                  <div className="legal-shadow absolute top-14 left-0 w-full rounded-[10px] py-2 flex flex-col gap-2 bg-white z-30">
                    {legalType?.map((inquiry, index) => (
                      <>
                        <p
                          className={`py-2 text-textExtraSmall font-semibold px-3 text-LightPrimary ${
                            index !== 0 ? 'mt-2' : ''
                          }`}
                          key={index + 1}
                        >
                          {inquiry.name}
                        </p>
                        {inquiry.legalOptions.map((list, index1) => (
                          <p
                            className={`py-2 text-textExtraSmall font-medium px-3 text-LightSecondary cursor-pointer hover:text-LightPrimary hover:bg-LightBgSecondary`}
                            key={index1}
                            onClick={() => handleClick(list.name, list.link)}
                          >
                            {list.name}
                          </p>
                        ))}
                      </>
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="w-full max-w-[850px] max_xl:max-w-[730px] max_md:max-w-[100%]">
            {children}
          </div>
        </div>
      </CommonSizeContainer>
    </div>
  );
};

export default LegalSideLayout;
